export default __webpack_public_path__ + "static/media/virus2.82db347e.png";